import {Pipe, PipeTransform} from '@angular/core';
import {FormuleProductEnum}  from "@shared/constants/formule-product.enum";
import { CONSTANTS }         from "@shared/constants/constants";

const COLOR_BY_FORMULE = {
    [FormuleProductEnum.FORMULE_GROUPAMA_SECURITE]:                 "#01AE99",
    [FormuleProductEnum.FORMULE_GROUPAMA_SECURITE_RENTE_EDUCATION]: "#8dbe3b",
    [FormuleProductEnum.FORMULE_GROUPAMA_GAV]:                      "#0085ab",
    [FormuleProductEnum.FORMULE_GROUPAMA_SERENITE_OBSEQUES]:        "#e83462",
    [CONSTANTS.DEFAULT]:                                        "#ffffff"
}

@Pipe({standalone:true,name: 'ColorPipe'})
export class ColorPipe implements PipeTransform {
    transform(keyFormule: string, border: boolean = true): any {
        const color = COLOR_BY_FORMULE[keyFormule] || COLOR_BY_FORMULE[CONSTANTS.DEFAULT]
        let style = {
            color : color,
            border: {}
        };
        if(border) {
            style = {
                ...style,
                border: `4px solid ${color}`
            }
        }
        return style;
    }
}
